import { useAppSelector } from 'shared/hooks/redux/hooks';
import { createSelector } from 'reselect';
import { selectDeviceFields } from 'entities/device/lib/selectors';
const selectDeviceForZ3kSettings = (device_id) => createSelector(selectDeviceFields(device_id, [
    'id',
    'z3k_config',
    'hardware_type',
    'device_type',
    'ui_settings',
    'firmware_version',
    'individual_device_name',
    'name',
    'timezone',
    'stationary_location',
]), (dev) => (dev != null ? dev : null));
const selectZ3kStateForZ3kSettings = (device_id) => createSelector(selectDeviceFields(device_id, ['z3k_state']), (dev) => dev != null ? dev?.z3k_state : undefined);
export function useGetZ3kSettingsData(device_id) {
    const device = useAppSelector(selectDeviceForZ3kSettings(device_id));
    const z3k_state = useAppSelector(selectZ3kStateForZ3kSettings(device_id));
    return { device, z3k_state };
}
